// React
import axios from "axios";
import React, { useState, useEffect } from "react";

// Ionic
import {
  IonContent,
  IonPage,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
  IonHeader,
  IonToolbar,
  IonIcon,
  IonModal,
} from "@ionic/react";

/*import { useLocation } from 'react-router-dom';*/

// Components
/*** Header ***/
/*import Toolbar from "../components/Header/Toolbar";*/
/*** Search ***/
import InfoCard from "../components/Search/InfoCard";
import SearchInput from "../components/Search/SearchInput";
import Filter from "../components/Search/Filter";
import Map from "../components/Map/Map";
import Marker from "../components/Map/Marker";
//CSS

// Packages
import { Wrapper } from "@googlemaps/react-wrapper";

// Data
import UserService from "../Context/user.service";
import ModalBookmark from "../Context/bookmark.modal";

//CSS
import {
  scanOutline,
} from "ionicons/icons";
import ClusterMarker from "../components/Map/MarkerCluster";
import userService from "../Context/user.service";

const render = (status) => {
  return <h1>{status}</h1>;
};

// Function Component Export
function Search(props) {
  var userInitial = 0;
  var logedInInitial = false;
  var isProinitial = false;
  var tokenInitial = "";

  const tokenData = UserService.getUserData();

  if (typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {
    userInitial = tokenData["tokenData"].MerchantCustomerId;
    logedInInitial = true;

    if (tokenData.login == 1) {
      logedInInitial = true;
    }
    if (tokenData.pro == 1) {
      isProinitial = true;
    }

    tokenInitial = tokenData.cookie;
  }

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPro, setIsPro] = useState(isProinitial);
  const [isLoggedIn, setIsLoggedIn] = useState(logedInInitial);
  const [user, setUser] = useState(userInitial);
  const [token, setToken] = useState(tokenInitial);
  const [pitchList, setPitchList] = useState();
  const [localprofileData, setlocalprofileData] = useState([]);
  // kostenlos RAUS NEHMEN - Nur drin damit ein Ergebnis angezeigt wird
  const [dog, setDog] = useState(false);
  const [disposal, setDisposal] = useState(false);
  const [forfree, setForfree] = useState(false);
  const [items, setItems] = useState([]);
  const [searchType, setSearchType] = useState("");
  const [searchlocation, setSearchlocation] = useState({ lat: "", lng: "" });
  const [previousSearch, setpreviousSearch] = useState([]);
  const [bookmark, setbookmark] = useState([]);
  const [allbookmarks, setAllBookmarks] = useState([]);
  const [previousVisible, setpreviousVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchParam] = useState(["anfahrt_d", "anfahrt_e"]);
  const [markers, setMarkers] = useState([]);
  const [zoom, setZoom] = useState(11); // initial zoom
  const [mapTypeId, setmapTypeId] = useState("roadmap"); // initial zoom
  const initialRendered = false;
  const [showResultModal, setShowResultModal] = useState(false);
  const [clusterRendered, setClusterRendered] = useState(false);
  const [plusFilterValue, setPlusFilterValue] = useState("");
  const [showAreaSearchBt, setShowAreaSearchBt] = useState(false);
  const [showAreaWasClicked, setShowAreaWasClicked] = useState(false);
  const [profileInterests, setProfileInterests] = useState([]);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [showFilterAndBackToSearch, setshowFilterAndBackToSearch] = useState(true);
  var accessRights = [];

  const [center, setCenter] = useState({
    lat: 51.125732475473455,
    lng: 10.099784125401262,
  });
  const pid = user;

  var defaultValueFilter = {
    features: [],
    underground: [],
    interests: [],
    searchinput: "",
    typePitch: true,
    typeService: false,
    gespanneErlaubt: false,
    voucher: false,
    price: { lower: 0, upper: 30 },
    vehicle_length: { lower: 4, upper: 15 },
    noofpitches: { lower: 1, upper: 40 },
  };

  window.allMarker = [];

  if (isProinitial === true) {
    defaultValueFilter.typeService = true;
  }

  const [activeFilter, setActiveFilter] = useState(defaultValueFilter);

  const sendserch = function () {
    setTimeout(function () {
      handleSearchSubmit();
    }, 150);
  };

  const versorgung = [
    "Stromanschlüsse",
    "Frischwasser",
    "WC",
    "Dusche",
    "Chemietoiletten-Entsorgung",
    "Grauwasser-Entsorgung",
    "Müll-Entsorgung",
  ];

  const austattung = [
    "Einrichtungen für Kinder",
    "Rollstuhlgerecht",
    "Hunde erlaubt",
    "WLAN-Hotspot",
    "Gasflaschentausch",
    "Schwimmbad",
    "Hallenbad",
    "Liegewiese",
    "Grillplatz",
    "Fahrradverleih",
    "Restaurants",
  ];

  const underground = [
    "Schotterrasen",
    "Wiese",
    "Asphalt",
    "Rasengittersteine",
    "Pflaster",
    "Schotter",
    "Kiesel",
    "Sand/Splitt",
    "Naturboden",
    "Eco-Raster/Gras",
  ];

  const interests = {
    Genuss: {
      Restaurant: "a",
      Winzer: "b",
      Brauereien: "c",
    },
    "Wellness & Gesundheit": {
      Thermen: "",
      Wellness: "",
    },
    "Kultur & Geschichte": {
      "Schlösser und Burgen": "",
      "Kultur -und Technikmuseum": "",
      Städte: "",
    },
    "Schwimmen & Baden": {
      "Freizeit -und Erlebnisbad": "",
      Badesee: "",
      Meer: "",
    },
    "Sport und Spaß": {
      Seilbahn: "p",
      Skilift: "l",
      Golfplatz: "l",
      Freizeitpark: "p",
      Yachthafen: "",
      Angeln: "",
      Klettern: "",
      Radfahren: "",
      Mountainbiking: "",
      Wandern: "",
    },
    "Naturnah übernachten": {
      Bauernhof: "",
      Naturpark: "",
      "Im Grünen": "",
      Naturnah: "",
      "Urlaub am Fluss": "",
    },
  };

  const interestsCat = [];

  for (const key in interests) {
    interestsCat.push(key);
  }

  /*************************  MAPS HANDLERS ************************* */
  const onClick = (e) => {
    // avoid directly mutating state
    //setMarkers([...markers, e.latLng]);
  };

  const onLoad = function (m) {
    //onIdle(m);
  };

  const onIdle = (m) => {};

  function removeAllItems() {
    setItems([]);
  }

  const setMapCenter = (items) => {
    setTimeout(function (){
      if(typeof items !== "undefined") {
        var bounds = new window.google.maps.LatLngBounds();
        console.log(bounds);
        console.log(items);
        items.forEach((item) => {
          var cords = new window.google.maps.LatLng(
              item.gps.latitude,
              item.gps.longitude
          );
          bounds.extend(cords);
        });

        window.gmap.fitBounds(bounds);

        if (items.length ==1) {
          setCenter(window.gmap.getCenter());
        } else {


        }

        /*          var getZoom = zoom;
          setTimeout(function (){
            setCenter(window.gmap.getCenter());
            setZoom(getZoom);

          },150)*/


        setShowAreaSearchBt(false);

        //setCenter(window.gmap.getCenter());
      }
    },0)
  };

  if (
    typeof window.parent.seturl !== "undefined" &&
    window.self.location.href.indexOf("home") !== -1
  ) {
    setTimeout(function () {
      window.parent.seturl("search", "");
    }, 350);
  }

  /*************************  GET PREVIOUS SEARCH + BOOMARK + FILTER DATA ON LOAD************************* */
  useEffect(() => {
    // Set Parameter
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("special")) {
      setPlusFilterValue(urlParams.get("special"));
    }

    // recenter map if hisitory back
    window.onpopstate = () => {
      if (window.location.href.indexOf("/home") !== -1) {
        setIsLoaded(false);
        setIsLoaded(true);
        setTimeout(function () {
          setMapCenter(window.gmap.items);

        }, 150);
      }
    };

    // Get Previous Results if User is Pro Member
    isLoggedIn &&
      UserService.getPreviousSearchs(pid, token).then(
        (response) => {
          var revSearches = response.data[0].lastsearch.reverse();
          setpreviousSearch(revSearches);
          //setIsLoaded(true);
        },
        (error) => {
          setError(error);
        }
      );
    // Get Bookmark Results if User is Pro Member
    isLoggedIn &&
      UserService.getBookmarks(pid, token).then(
        (response) => {
          setbookmark(response.data);

          var allb = [];
          response.data.lists.forEach((list) => {
            list.items.forEach((item) => {
              if (typeof item === "number") {
                allb.push(item);
              }
            });
          });

          //setAllBookmarks
          setAllBookmarks(allb);
          setIsLoaded(true);
        },
        (error) => {
          setError(error);
        }
      );

    isLoggedIn &&
      UserService.getPelnigoAccessItemsFromAPI(pid, token).then(
        (response) => {
          accessRights = response.data.items;
          window.accessRights = response.data.items;
        },
        (error) => {
          console.log(error);
        }
      );

    //perselect search if WP Search is active
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    if (typeof params !== "undefined" || typeof params.s !== "undefined") {
      if (typeof params.s !== "undefined") {
        setTimeout(function () {
          setSearchText(params.s);
          document.querySelector(".search__button").click();
        }, 500);
      } else if (
        typeof params.special !== "undefined" &&
        params.special !== null
      ) {
        setTimeout(function () {
          fireSearch("&hasfilter=1&special=" + params.special);
        }, 500);
      } else if (typeof params.ids !== "undefined" && params.ids !== null) {
        setshowFilterAndBackToSearch(false);
        setTimeout(function () {
          fireSearch("&hasfilter=1&ids=" + params.ids);
        }, 500);
      } else if (typeof params.tag !== "undefined" && params.tag !== null) {
        setshowFilterAndBackToSearch(false);
        setTimeout(function () {
          fireSearch("&hasfilter=1&tag=" + params.tag);
        }, 500);
      } else if (typeof params.typ !== "undefined" && params.typ !== null) {
        setTimeout(function () {
          fireSearch("&hasfilter=1&typ=" + params.typ);
        }, 500);
      } else {
        setTimeout(function () {
          fireSearch();
        }, 500);
      }
    } else {
      // previsos search
      if (localStorage.getItem("ba-filter") !== null) {
        var prefilter = JSON.parse(localStorage.getItem("ba-filter"));

        if (
          document.querySelector("[value='dog']") !== null &&
          document.querySelector("[value='dog']").getAttribute("active") ==
            "true" &&
          isPro
        ) {
          prefilter.searchstring += "&features[]=Hunde erlaubt";
          prefilter["features"].push("Hunde erlaubt");
        }

        if (prefilter["ve"] == 1) {
          setDisposal(true);
        }

        if (
          prefilter["price"]["lower"] == 0 &&
          prefilter["price"]["upper"] == 0
        ) {
          setForfree(true);
        }

        setActiveFilter(prefilter);
        setSearchText(prefilter.address);

        setTimeout(function () {
          fireSearch(prefilter.searchstring);
        }, 350);
      } else {
        // load default data
        UserService.getPublicContent("", isPro).then(
          (response) => {
            if (response.data.data.length > 0) {
              removeAllItems();

              setItems(response.data.data);
              setSearchType(response.data.type);
              setSearchlocation(response.data.searchpos);

              setIsLoaded(true);
              setMapCenter(response.data.data);
              console.log(response.data.data);

              setSearchMarker(response);
            } else {
              setShowResultModal(true);
            }
          },
          (error) => {
            setError(error);
          }
        );
      }
    }

    // Load previous search

    // Only get User Profile
    if (isLoggedIn && isPro) {
      UserService.getProfileFields(user, token).then((response) => {
        setProfileInterests(response.data[0].interests);

        if (
          typeof response.data[0] !== "undefined" &&
          response.data[0].crew.indexOf("Mit Hund") !== -1
        ) {
          setDog(true);
        } /*else if (key === "forfree") {
          setForfree(true);
        } else if (key === "disposal") {
          setDisposal(true);
        }*/
      });
    }
    if (!isLoggedIn) {
      setIsLoaded(true);
    }
  }, []);

  const setSearchMarker = (response) => {
    var search_marker = new window.google.maps.Marker({
      position: {
        lat: response.data.searchpos.lat * 1,
        lng: response.data.searchpos.lng * 1,
      },
      /*            icon: {
                    url:""
                  },
                  optimized: false,*/
      title: "Standort",
    });
    if (typeof window.search_marker !== "undefined") {
      window.search_marker.setMap(null);
    }
    window.search_marker = search_marker;
    window.search_marker.setMap(window.gmap);
  };

  const resetSearch = () => {
    setActiveFilter(defaultValueFilter);
    localStorage.removeItem("ba-filter");
    setSearchText("");
    fireSearch("");
    setDog(false);
    setForfree(false);
    setDisposal(false);
  };

  /*******************************************  SEARCH INPUT HANDLERS ********************************** */
  const handleSearchTextChange = (e) => {
    setSearchText(e);
  };

  const updatePrevSearch = (previousSearchinput) => {
    if (previousSearchinput === "" || isLoggedIn === false) {
      return false;
    }

    setpreviousSearch(previousSearchinput);
    var previousSearchString = previousSearchinput.join(",");

    try {
      const response = axios.post(
        window.location.origin +
          "/api/?action=update_lastsearch&pid=" +
          pid +
          "&lastsearch=" +
          previousSearchString +
          "&token=" +
          token,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const handleAreaSearch = () => {
    document
      .getElementById("searchinput")
      .setAttribute("data-lat", window.gmap.getCenter().lat());
    document
      .getElementById("searchinput")
      .setAttribute("data-lng", window.gmap.getCenter().lng());
    setSearchText("Eigener Standort");
    setTimeout(function () {
      document.querySelector(".search__button").click();
    }, 300);

    /*    var bounds = window.gmap.getBounds();
    //var nw = bounds.getNorthWest();
    var ne = bounds.getNorthEast();
    //var se = bounds.getSouthEast();
    var sw = bounds.getSouthWest();
    var searchstring = '';
    var square = {
      'x1' : bounds.getNorthEast().lat(),
      'y1' : bounds.getSouthWest().lng(),
      'x2' : ne.lat(),
      'y2' : ne.lng(),
      'x3' : bounds.getSouthWest().lat(),
      'y3' : bounds.getNorthEast().lng(),
      'x4' : sw.lat(),
      'y4' : sw.lng(),
    }

    var baFilter = activeFilter;

    if(typeof  baFilter !== "undefined" && typeof  baFilter["searchstring"] !== "undefined") {
      baFilter["searchstring"] += "&sqare[x1]="+square.x1+"&sqare[y1]="+square.y1+"&sqare[x2]="+square.x2+"&sqare[y2]="+square.y2+"&sqare[x3]="+square.x3+"&sqare[y3]="+square.y3+"&sqare[x4]="+square.x4+"&sqare[y4]="+square.y4;

    } else {
      baFilter["searchstring"] = "&sqare[x1]="+square.x1+"&sqare[y1]="+square.y1+"&sqare[x2]="+square.x2+"&sqare[y2]="+square.y2+"&sqare[x3]="+square.x3+"&sqare[y3]="+square.y3+"&sqare[x4]="+square.x4+"&sqare[y4]="+square.y4;

    }*/
    setShowAreaWasClicked(true);
    setShowAreaSearchBt(false);
  };

  const handleSearchSubmit = (e) => {
    // Hide the previous searchs and bookmarks
    setpreviousVisible(false);

    // build searchstring
    var baFilter = defaultValueFilter;

    // Location search
    var searchstring = "&hasfilter=1";
    var searchinput = document.querySelector("#searchinput").value;

    if (typeof searchinput !== "undefined" && searchinput != "") {
      if (searchinput === "Eigener Standort") {
        searchstring +=
          "&lat=" +
          document.getElementById("searchinput").getAttribute("data-lat") +
          "&lng=" +
          document.getElementById("searchinput").getAttribute("data-lng");
      } else {
        searchstring += "&address=" + searchinput;
        baFilter["address"] = searchinput;

        //check and add to lastsearch
        if (previousSearch.indexOf(searchinput) === -1) {
          previousSearch.push(searchinput);
        } else {
          previousSearch.splice(previousSearch.indexOf(searchinput), 1);
          previousSearch.unshift(searchinput);
        }
        updatePrevSearch(previousSearch);
      }
    }
    //

    // buttons ---------------------------------
    //dog search
    if (
      document.querySelector("[value='dog']") !== null &&
      document.querySelector("[value='dog']").getAttribute("active") == "true"
    ) {
      searchstring += "&features[]=Hunde erlaubt";
      baFilter["features"].push("Hunde erlaubt");
    }

    // muss ich das Umbauen des Dusche-Filters dann auch hier über eine Sonderregel auffangen?

    if (
      document.querySelector("[value='disposal']") !== null &&
      document.querySelector("[value='disposal']").getAttribute("active") ==
        "true"
    ) {
      searchstring += "&ve=1";
      baFilter["ve"] = 1;
    }

    // price
    if (
      document.querySelector("#filtermodal").classList.contains("show-modal") &&
      typeof document.querySelector("#price2").value.lower !== "undefined"
    ) {
      searchstring +=
        "&price_lower=" + document.querySelector("#price2").value.lower;
      searchstring +=
        "&price_upper=" + document.querySelector("#price2").value.upper;
      baFilter["price"] = document.querySelector("#price2").value;
    } else {
      //forfree
      if (
        document.querySelector("[value='forfree']") !== null &&
        document.querySelector("[value='forfree']").getAttribute("active") ==
          "true"
      ) {
        searchstring += "&price_lower=0&price_upper=0";
        baFilter["price"] = { lower: 0, upper: 0 };
      }
    }

    //filter  ---------------------------------

    //Schieberegler
    if (
      document.querySelector("#filtermodal").classList.contains("show-modal")
    ) {
      //Stellplatztypen

      if (
        typeof document.querySelector("[name='type-pitch']") !== "undefined" &&
        document.querySelector("[name='type-pitch']") !== null &&
        document
          .querySelector("[name='type-pitch']")
          .classList.contains("checkbox-checked")
      ) {
        searchstring += "&pitch=1";
        baFilter["typePitch"] = true;
      } else {
        searchstring += "&pitch=0";
        baFilter["typePitch"] = false;
      }

      if (
        (typeof document.querySelector("[name='type-service']") !==
          "undefined" &&
          document.querySelector("[name='type-service']") !== null &&
          document
            .querySelector("[name='type-service']")
            .classList.contains("checkbox-checked")) ||
        window.location.href.indexOf("typ=Entsorgungsstation") !== -1
      ) {
        searchstring += "&service=1";
        baFilter["typeService"] = true;
      } else {
        searchstring += "&service=0";
        baFilter["typeService"] = false;
      }

      if (
        typeof document.querySelector("[name='gespanneErlaubt']") !==
          "undefined" &&
        document.querySelector("[name='gespanneErlaubt']") !== null &&
        document
          .querySelector("[name='gespanneErlaubt']")
          .classList.contains("checkbox-checked")
      ) {
        searchstring += "&gespanne-erlaubt=1";
        baFilter["gespanneErlaubt"] = true;
      } else {
        searchstring += "&gespanne-erlaubt=0";
        baFilter["gespanneErlaubt"] = false;
      }

      if (
        typeof document.querySelector("[name='type-voucher']") !==
          "undefined" &&
        document.querySelector("[name='type-voucher']") !== null &&
        document
          .querySelector("[name='type-voucher']")
          .classList.contains("checkbox-checked")
      ) {
        searchstring += "&voucher=1";
        baFilter["voucher"] = true;
      } else {
        baFilter["voucher"] = false;
      }

      if (
        typeof document.querySelector("#vehicle_length").value.lower !==
        "undefined"
      ) {
        searchstring +=
          "&vehicle_length_lower=" +
          document.querySelector("#vehicle_length").value.lower;
        searchstring +=
          "&vehicle_length_upper=" +
          document.querySelector("#vehicle_length").value.upper;
        baFilter["vehicle_length"] =
          document.querySelector("#vehicle_length").value;
      }

      if (
        typeof document.querySelector("#noofpitches").value.lower !==
        "undefined"
      ) {
        searchstring +=
          "&noofpitches_lower=" +
          document.querySelector("#noofpitches").value.lower;
        searchstring +=
          "&noofpitches_upper=" +
          document.querySelector("#noofpitches").value.upper;
        baFilter["noofpitches"] = document.querySelector("#noofpitches").value;
      }

      //Austattung
      austattung.forEach((element, index) => {
        if (
          document
            .querySelector("[value='" + element + "']")
            .classList.contains("checkbox-checked")
        ) {
          searchstring += "&features[]=" + element;
          baFilter["features"].push(element);
        }
      });

      //underground
      underground.forEach((element, index) => {
        if (
          document
            .querySelector("[value='" + element + "']")
            .getAttribute("aria-checked") == "true"
        ) {
          searchstring += "&underground[]=" + element;
          baFilter["underground"].push(element);
        }
      });

      //versorgung
      versorgung.forEach((element, index) => {
        if (
          document
            .querySelector("[value='" + element + "']")
            .getAttribute("aria-checked") == "true"
        ) {
          searchstring += "&features[]=" + element;
          baFilter["features"].push(element);
        }
      });

      //interests

      for (const key in interests) {
        for (const subkey in interests[key]) {
          if (
            document
              .querySelector("[value='" + subkey + "']")
              .getAttribute("aria-checked") == "true"
          ) {
            searchstring += "&interests[]=" + subkey;
            baFilter["interests"].push(subkey);
          }
        }
      }
    }

    // Save Search
    baFilter["searchstring"] = searchstring;
    localStorage.setItem("ba-filter", JSON.stringify(baFilter));

    setActiveFilter(baFilter);

    /*
    defaultValueFilter = baFilter;
*/
    // Receive Data and show Infocards + Marker
    fireSearch(searchstring);
  };

  const fireSearch = (searchstring) => {
    UserService.getPublicContent(searchstring, isPro).then(
      (response) => {
        // Variables and Arrays
        const responseData = response.data.data;
        //setPitchList(responseData);
        let itemList = [];

        // Set the filtered List to the State

        if (response.data.data.length > 0) {
          removeAllItems();

          setItems(responseData);
          setSearchType(response.data.type);
          setSearchlocation(response.data.searchpos);

          setIsLoaded(true);
          setMapCenter(responseData);
          console.log('hier');
          console.log(responseData);

          setSearchMarker(response);
        } else {
          setShowResultModal(true);
        }
      },
      (error) => {
        setError(error);
      }
    );
  };

  const handleSearchFocus = () => {
    setpreviousVisible(true);
  };
  const handleSearchBlur = () => {
    // Delay blur function to prevent Data from disappearing to quick
    function delay(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    }
    delay(300).then(() => setpreviousVisible(false));
  };
  const handleDeletePreviousSelect = (e) => {
    previousSearch.splice(previousSearch.indexOf(e), 1);
    updatePrevSearch(previousSearch);
    // SEND DATA TO DB to delete
  };
  const handlePreviousSelect = (e) => {
    setSearchText(e);
    setTimeout(function () {
      handleSearchSubmit(e);
    });
  };
  const handleNormalSubmit = (e) => {
    handleSearchSubmit(searchText);
  };

  /********************************** FILTER INPUT HANDLERS *************************/

  function handleFilterKlick(buttonValue) {
    // are there any previous searches?

    // Set buttonValue to active or not (true or false)
    if (buttonValue === "dog") {
      if (
        document.querySelector("[value='dog']").getAttribute("active") == "true"
      ) {
        setDog(false);
      } else {
        setDog(true);
      }
    } else if (buttonValue === "forfree") {
      setForfree((prevValue) => !prevValue);
    } else if (buttonValue === "disposal") {
      setDisposal((prevValue) => !prevValue);
    }

    setTimeout(function () {
      handleSearchSubmit("");
    }, 150);
  }

  /* FULL WIDTH MOBILE MAP */
  const handlefullWidthMap = () => {
    let mapWrapper = document.querySelector(".search__maps");
    mapWrapper.classList.toggle("fullwidth");
  };

  return isLoaded ? (
    <IonPage
      className={`${isLoggedIn ? "is-logged-in" : "not-logged-in"} ${
        isPro ? "is-pro" : "not-pro"
      }`}
    >
      {/*      <IonHeader>
        <Toolbar />
      </IonHeader>*/}

      <ModalBookmark
        isLoggedInValue={isLoggedIn}
        isProValue={isPro}
        pid={pid}
        token={token}
        bookmark={bookmark}
        setbookmark={setbookmark}
        setIsLoaded={setIsLoaded}
      />
      <IonContent fullscreen>
        <IonGrid>
          <IonRow>
            <IonCol className="search__maps" size="12" size-md="6" size-lg="8">
              <div style={{ display: "flex", height: "100%" }}>
                <Wrapper
                  apiKey={"AIzaSyA_F83EK6cz_LUYSGUSCdcmLDZja7Dk0ho"}
                  render={render}
                >
                  {showAreaSearchBt === true &&
                    window.location.href.indexOf("typ=Entsorgungsstation") ===
                      -1 && (
                      <IonRow className="search_area_wrapper">
                        <IonButton
                          shape="round"
                          color="secondary"
                          id="areaSearch"
                          onClick={() => handleAreaSearch()}
                          className="route__open__button search_area ion-color ion-color-secondary md button button-block button-round button-solid ion-activatable ion-focusable"
                        >
                          In diesem Bereich suchen
                        </IonButton>
                      </IonRow>
                    )}
                  <IonButton
                    shape="round"
                    color="primary"
                    id="fullWidthMap"
                    onClick={() => handlefullWidthMap()}
                    className="fullWidthMap"
                  >
                    <IonIcon icon={scanOutline} color="light" />
                  </IonButton>
                  <Map
                    id="mainmap"
                    center={center}
                    zoom={zoom}
                    setShowAreaSearchBt={setShowAreaSearchBt}
                    style={{ flexGrow: "1", height: "100%" }}
                    mapTypeId={mapTypeId}
                    items={items}
                  >
                    {searchType != "country" &&
                      items.length <= 300 &&
                      items.map((item) => (
                        <Marker
                          position={{
                            lat: parseFloat(item.gps.latitude),
                            lng: parseFloat(item.gps.longitude),
                          }}
                          id={item.id}
                          name={item.stellplatzname}
                          marker={item.stellplatztyp}
                          premium={item.premium}
                        />
                      ))}

                    {(searchType == "country" || items.length > 300) && (
                      <div id={"clustermap"}>
                        <ClusterMarker
                          setClusterRendered={setClusterRendered}
                          items={items}
                        />
                      </div>
                    )}
                  </Map>
                </Wrapper>
              </div>
            </IonCol>
            <IonCol
              className="search__infocard"
              size="12"
              size-md="6"
              size-lg="4"
            >
              <div
                className={`${
                  window.location.href.indexOf("typ=Entsorgungsstation") !== -1
                    ? "forceshow search__inputWrapper"
                    : "search__inputWrapper"
                }`}
              >
                {(function () {
                  if (window.location.hash != "#nosearch") {
                    return (
                      <SearchInput
                        value={searchText}
                        onSearchTextChange={handleSearchTextChange}
                        onSearchSubmit={handleNormalSubmit}
                        onSearchFocus={handleSearchFocus}
                        onSearchBlur={handleSearchBlur}
                        onPreviousSelect={handlePreviousSelect}
                        deletePreviousSelect={handleDeletePreviousSelect}
                        previousVisibleValue={previousVisible}
                        isLoggedInValue={isLoggedIn}
                        isProValue={isPro}
                        previousSearchValue={previousSearch}
                        bookmarkValue={bookmark}
                        activeFilter={activeFilter}
                        setActiveFilter={setActiveFilter}
                        setSearchText={setSearchText}
                      />
                    );
                  }
                })()}

                {(function () {
                  if (window.location.hash != "#nosearch") {
                    return (
                      <Filter
                        isLoggedInValue={isLoggedIn}
                        isProValue={isPro}
                        onFilterClick={handleFilterKlick}
                        dogValue={dog}
                        disposalValue={disposal}
                        forfreeValue={forfree}
                        sendSearch={sendserch}
                        versorgung={versorgung}
                        austattung={austattung}
                        underground={underground}
                        interests={interests}
                        interestsCat={interestsCat}
                        activeFilter={activeFilter}
                        resetSearch={resetSearch}
                        setActiveFilter={setActiveFilter}
                        initialRendered={initialRendered}
                        fireSearch={fireSearch}
                      />
                    );
                  } else if (
                    window.location.hash === "#nosearch" &&
                    window.location.href.indexOf("map") !== -1
                  ) {
                    return (
                      <>
                        {showFilterAndBackToSearch === true ? (
                          <h3 className="ion-padding-start">
                            +Filter: {plusFilterValue}
                          </h3>
                        ) : (<></>)}
                        <h5 className="ion-padding-start">
                          {items.length} Stellplätze gefunden
                        </h5>
                        {showFilterAndBackToSearch === true ? (
                          <a onClick={() => userService.goToURL("/app/")}>
                          <IonButton shape="round" expand="block">
                            Zurück zur Suche
                          </IonButton>
                        </a>
                        ) : (<></>)}
                        <br />

                        {plusFilterValue === "Bauernhöfe" ? (
                          <a
                            onClick={() =>
                              userService.goToURL("/specials-item/bauernhoefe/")
                            }
                          >
                            <img src="/wp-content/uploads/2023/06/BannerStellplatzPlusBauernhoefebeiPlusFilter.jpg" alt="Landerlebnis mit dem Wohnmobil" className="special__crosslinkimg"/>
                          </a>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  }
                })()}
              </div>

              {items.map((item) => {
                if (
                  typeof item.features === "undefined" ||
                  item.features === null
                ) {
                  item.features = {
                    feature: [],
                  };
                }

                var fav = false;
                if (allbookmarks.indexOf(item.id) !== -1) {
                  fav = true;
                }

                if (typeof item.place === "undefined") {
                  item.place = { maxLengthOfPitches: "" };
                }
                if (typeof item.search === "undefined") {
                  item.search = { price: "" };
                }
                if (typeof item.basicCosts === "undefined") {
                  item.basicCosts = { currency: "" };
                }
                if (typeof item.vouchers === "undefined") {
                  item.vouchers = { voucher: [] };
                }
                if (typeof item.prices === "undefined") {
                  item.prices = { generalPrice: "" };
                }

                return (
                  <>
                    <InfoCard
                      key={item.id}
                      id={item.id}
                      slug={item.slug}
                      name={item.stellplatzname}
                      url={item.mainimage}
                      description={item.description}
                      latitude={parseFloat(item.gps.latitude)}
                      longitude={parseFloat(item.gps.longitude)}
                      distance={parseFloat(item.distance)}
                      stellplaetzeLaenge={item.place.maxLengthOfPitches}
                      vergleichspreis={item.search.price}
                      preiseWaehrung={item.basicCosts.currency}
                      voucher={item.vouchers.voucher}
                      ausstattung={item.features.feature}
                      premium={item.premium}
                      fav={fav}
                      city={item.city}
                      country={item.countryName}
                      responseType={searchType}
                      stellplatztyp={item.stellplatztyp}
                      entsorgungsstation={item.entsorgungsstation}
                      interests={profileInterests}
                      category={item.category}
                      subcategories={item.subcategories}
                      interesttags={item.tags}
                      labelpreis={item.prices.generalPrice}
                    />
                  </>
                );
              })}
              {/*  {search(items).map((item) => {
                return (
                  <InfoCard
                    id={item.id}
                    name={item.name}
                    url={
                      "https://images.unsplash.com/photo-1515876305430-f06edab8282a?crop=entropy&cs=tinysrgb&fm=jpg&ixlib=rb-1.2.1&q=80&raw_url=true&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770"
                    }
                    description={item.description}
                    latitude={item.location.latitude}
                    longitude={item.location.longitude}
                    stellplaetzeLaenge={item.legacy_data.stellplaetze_laenge}
                    vergleichspreis={item.legacy_data.vergleichspreis}
                    preiseWaehrung={item.legacy_data.preise_waehrung}
                  />
                );
              })} */}
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonModal
          isOpen={showResultModal}
          id="showResultModal"
          onWillDismiss={() => setShowResultModal(false)}
        >
          <IonHeader>
            <IonToolbar>
              <h4 className="ion-padding-start">Kein Ergebnis</h4>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <p className="ion-padding-start">
              Leider kein Ergebnis für diese Suche in dieser Region. Bitte passe
              deine Suche oder deine Suchregion an.
            </p>
            <p className="ion-padding-start">
              <IonButton
                onClick={() => setShowResultModal(false)}
                color="primary"
              >
                Zurück zur Suche
              </IonButton>
            </p>
          </IonContent>
        </IonModal>

        {/*
        <IonModal isOpen={showModalDetail} cssClass="entsorgungs-modal">

          <div id="showModalDetailContent"></div>
          <IonButton onClick={() => setShowModalDetail(false)}>Close Modal</IonButton>
        </IonModal>
        <IonButton id="setShowModalDetail" onClick={() => setShowModalDetail(true)}>Show Modal</IonButton>*/}
      </IonContent>
    </IonPage>
  ) : (
    <></>
  );
}

export default Search;
